/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Story_BodyInputs */

const vi_shop_home_story_body = /** @type {(inputs: Shop_Home_Story_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

/**

* @param {Shop_Home_Story_BodyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_story_body = /** @type {((inputs?: Shop_Home_Story_BodyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Story_BodyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_story_body(inputs)
});